<template>
  <div class="form-row mb-0 mt-4 justify-end lg:justify-start">
    <ButtonShareFacebook
      class="col-auto px-2 mr-2"
      :url="url"
      :icon-only="true"
    />
    <!-- copy link -->
    <a
      :href="url"
      class="btn col-auto py-2 sm:py-3 lg:px-5 rounded-pill font-medium"
      :class="[linkIsCopied ? 'btn-outline-success' : 'btn-outline-primary']"
      @click="copyLink"
    >
      {{ linkIsCopied ? t('link_copied') : t('copy_link') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import ButtonShareFacebook from '@/components/buttons/ButtonShareFacebook.vue'

const { t } = useI18n()
const route = useRoute()
const linkIsCopied = ref(false)

const base_url = computed(() => {
  const baseUrl = import.meta.env.VITE_VUE_APP_ORIGINAL_URL
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
})

const url = computed(() => {
  return `${base_url.value}${route.fullPath}`
})

const copyLink = (event: MouseEvent) => {
  event.preventDefault()

  // create textarea to copy link
  const el = document.createElement('textarea')
  el.value = (event.target as HTMLElement | null)?.getAttribute('href')!
  el.classList.add('sr-only')
  document.body.append(el)
  el.select()
  document.execCommand('copy')
  el.remove()

  linkIsCopied.value = true
  setTimeout(() => {
    linkIsCopied.value = false
  }, 2000)
}
</script>

<i18n>
  {
    "cs": {
    "copy_link": "Zkopírovat odkaz",
    "link_copied": "Odkaz zkopírován"
},
    "sk": {
    "copy_link": "Skopírujte si odkaz",
    "link_copied": "Odkaz skopírovaný"
},
    "pl": {
    "copy_link": "Skopiuj link",
    "link_copied": "Link został skopiowany"
},
    "hu": {
    "copy_link": "Link másolása",
    "link_copied": "A link másolva"
},
    "de": {
    "copy_link": "Link kopieren",
    "link_copied": "Link kopiert"
},
    "at": {
    "copy_link": "Link kopieren",
    "link_copied": "Link kopiert"
},
    "ro": {
    "copy_link": "Copiază linkul",
    "link_copied": "Linkul a fost copiat"
},
    "fr": {
    "copy_link": "Copier le lien",
    "link_copied": "Lien copié"
},
    "it": {
    "copy_link": "Copia il link",
    "link_copied": "Link copiato"
}
  }
</i18n>
